import { Link } from 'react-router';
import { useOffline } from '../offline/context.js';

/**
 * Top bar indicator (brief section 9): nothing when everything is sent;
 * "Waiting for network" with the count while changes wait on the device;
 * red when the server refused some of them. It opens the Changes not sent page.
 */
export function SyncStatus() {
  const { counts, sending, outcome } = useOffline();
  if (counts.pending === 0 && counts.rejected === 0) return null;
  const label =
    counts.rejected > 0
      ? 'Not sent'
      : sending
        ? 'Sending'
        : outcome === 'needs_sign_in'
          ? 'Sign in to send'
          : 'Waiting for network';
  const total = counts.pending + counts.rejected;
  return (
    <Link
      to="/sync"
      className={`syncpill${counts.rejected > 0 ? ' bad' : ''}`}
      aria-label={`${label}: ${total} ${total === 1 ? 'change' : 'changes'} not sent`}
    >
      <svg className="i" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 12a8 8 0 0 1 14-5.3M20 12a8 8 0 0 1-14 5.3M18 3v4h-4M6 21v-4h4" />
      </svg>
      <span className="syncpill-label">{label}</span>
      <b>{total}</b>
    </Link>
  );
}
